import { render, staticRenderFns } from "./account.vue?vue&type=template&id=db6e4198&"
import script from "./account.js?vue&type=script&lang=js&"
export * from "./account.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports